import { format } from 'date-fns';
import { legacyParse, convertTokens } from '@date-fns/upgrade/v2';

import { PARTNER_DATE_FIELD, PARTNER_STATUS_DISPLAY_KEYS } from './types';

export const formatPartnerDate = (date?: Date, formatString = 'MMM DD, YYYY'): string => {
  if (date) {
    return format(legacyParse(date), convertTokens(formatString));
  }

  return '-';
};

export const formatPartnerDateForPartnerStatus = (
  partner: Record<string, undefined>,
  partnerStatus: PARTNER_STATUS_DISPLAY_KEYS
): string => formatPartnerDate(partner[PARTNER_DATE_FIELD[partnerStatus]]);
